export default __webpack_public_path__ + "static/media/logo.398c8a28.svg";